import { format, parseISO } from 'date-fns';

export default function formatDate(key) {
  if (key && key.length > 1) return format(parseISO(key), 'dd-MM-yyyy HH:mm:ss');
  return '-';
}
